"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserPenSolid: function() {
        return UserPenSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserPenSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2 22C2 16.4772 6.47715 12 12 12C13.6689 12 15.2423 12.4088 16.6256 13.1318L12.1716 17.5858C11.4214 18.336 11 19.3534 11 20.4142V22C11 22.3507 11.0602 22.6872 11.1707 23H3C2.44772 23 2 22.5523 2 22Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M21 23H19.2427L21.8685 20.3742C21.955 20.9033 22 21.4464 22 22C22 22.5523 21.5523 23 21 23Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M21.7071 14.2929C20.7643 13.3501 19.2357 13.3501 18.2929 14.2929L13.5858 19C13.2107 19.3751 13 19.8838 13 20.4142V22C13 22.5523 13.4477 23 14 23H15.5858C16.1162 23 16.6249 22.7893 17 22.4142L21.7071 17.7071C22.6499 16.7643 22.6499 15.2357 21.7071 14.2929Z",
            fill: "currentColor"
        })
    ]
}), "UserPenSolid");
const _default = UserPenSolid;
